import {
  WORKFLOW_ACTIVITY_ACTION_CLICKED,
  WORKFLOW_ACTIVITY_ACTION_NOT_CLICKED,
  WORKFLOW_ACTIVITY_ACTION_NOT_OPENED,
  WORKFLOW_ACTIVITY_ACTION_ONE_ACTION,
  WORKFLOW_ACTIVITY_ACTION_OPENED,
  WORKFLOW_ACTIVITY_ACTION_OPTIONS,
  WORKFLOW_ACTIVITY_ACTION_TEN_ACTION
  //
} from 'Constants/'
import { FormElement, Select } from 'mailup-web-components'
import { step2State } from 'Pages/Workflow/recoil/state/step2'
import { useMemo, useState } from 'react'
import { useIntl } from 'react-intl'

import { useRecoilValue, useSetRecoilState } from 'recoil'

const activityTypesMsg = [
  WORKFLOW_ACTIVITY_ACTION_OPENED,
  WORKFLOW_ACTIVITY_ACTION_NOT_OPENED,
  WORKFLOW_ACTIVITY_ACTION_CLICKED,
  WORKFLOW_ACTIVITY_ACTION_NOT_CLICKED,
  WORKFLOW_ACTIVITY_ACTION_ONE_ACTION,
  WORKFLOW_ACTIVITY_ACTION_TEN_ACTION
]

const activityTypeMsgWithLinks = [
  WORKFLOW_ACTIVITY_ACTION_CLICKED,
  WORKFLOW_ACTIVITY_ACTION_NOT_CLICKED
]

const InputActivityType = () => {
  const intl = useIntl()

  const { ActivityType } = useRecoilValue(step2State)

  const [activityTypeIsDirty, setActivityTypeIsDirty] = useState(false)

  const setWorkflowDetailsState = useSetRecoilState(step2State)

  const activityTypeOptions = useMemo(() => {
    return WORKFLOW_ACTIVITY_ACTION_OPTIONS.map(({ label, value }) => ({
      value,
      label: intl.formatMessage({ id: label })
    }))
  }, [])

  const handleActivityTypeChange = (newActivityType) => {
    const toEmailType = activityTypesMsg.includes(newActivityType)
    const toLinkType = activityTypeMsgWithLinks.includes(newActivityType)

    setWorkflowDetailsState((prev) => {
      const fromEmailType = activityTypesMsg.includes(prev.ActivityType)

      const newIdMessage =
        !!newActivityType && toEmailType === fromEmailType ? prev.IdMessage : 0

      return {
        ...prev,
        ActivityType: newActivityType,
        IdMessage: newIdMessage,
        ClickedLink: toLinkType ? prev.ClickedLink : ''
      }
    })
    setActivityTypeIsDirty(true)
  }

  const requiredFeedback = intl.formatMessage({
    id: 'Load.MailupCommon.Required'
  })

  return (
    <FormElement
      label={intl.formatMessage({
        id: 'Load.AutomationWorkflow.ActivityActionLabel'
      })}
      required
      feedback={
        activityTypeIsDirty && !ActivityType ? requiredFeedback : undefined
      }
      variant={activityTypeIsDirty && !ActivityType ? 'danger' : undefined}
    >
      <Select
        searchable
        value={ActivityType}
        options={activityTypeOptions}
        onChange={handleActivityTypeChange}
        placeholder={intl.formatMessage({
          id: 'Load.AutomationWorkflow.ActivityActionPlaceholder'
        })}
        error={activityTypeIsDirty && !ActivityType}
      />
    </FormElement>
  )
}

export default InputActivityType
